// LEGACY hardcoded list — superseded by useSupportedCurrencies
// (features/regions/hooks), which derives the live list from GET /region/active,
// the same source the server validates against. Still imported by bundle-form
// and the pricing wizards; migrate those to the hook, then delete this file.
export const CURRENCIES = [
  { label: "Indian Rupee", value: "INR" },
  { label: "United Arab Emirates Dirham", value: "AED" },
  { label: "US Dollar", value: "USD" },
] as const;

export type Currency = (typeof CURRENCIES)[number]["value"];
